import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { T, useTranslate } from 'shared/helper/translate';
import Popover from 'researcher/components/Popover';
var RubriqDownloadButton = function RubriqDownloadButton(_ref) {
  var completed = _ref.completed,
    downloading = _ref.downloading,
    isLatex = _ref.isLatex,
    isPdfFailed = _ref.isPdfFailed,
    onDownload = _ref.onDownload;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  if (!isLatex) {
    return /*#__PURE__*/React.createElement(Popover, {
      content: "curie.download-file",
      "data-bs-toggle": "tooltip",
      "data-bs-placement": "bottom"
    }, /*#__PURE__*/React.createElement("button", {
      "aria-label": t('Downloading...'),
      type: "button",
      className: "not-global btn btn-primary rubriq-ghost-button",
      onClick: function onClick() {
        return onDownload(false);
      },
      disabled: !completed || downloading
    }, downloading ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: "fa-solid fa-spinner-scale",
      className: "me-1",
      spin: true
    }) : /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: "fa-light fa-file-arrow-down",
      className: "me-1",
      "data-testid": "rubriq-download-file"
    }), /*#__PURE__*/React.createElement(T, {
      source: downloading ? 'Downloading...' : ''
    })));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "dropdown rubriq-dropdown d-inline-block"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "not-global btn btn-primary rubriq-ghost-button dropdown-toggle",
    "data-bs-toggle": "dropdown",
    disabled: !completed || downloading
  }, /*#__PURE__*/React.createElement("span", null, downloading ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-spinner-scale",
    className: "me-1",
    spin: true
  }) : /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-light fa-file-arrow-down",
    className: "me-1"
  }), /*#__PURE__*/React.createElement(T, {
    source: downloading ? 'Downloading...' : ''
  }), /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-caret-down",
    className: "ms-1"
  }))), /*#__PURE__*/React.createElement("ul", {
    className: "dropdown-menu overflow-visible p-0"
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "dropdown-item fw-normal py-2 px-3 rubriq-dropdown-item",
    onClick: function onClick() {
      return onDownload(false);
    }
  }, /*#__PURE__*/React.createElement(T, {
    source: "Edited LaTeX file (.tex)"
  }))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "dropdown-item fw-normal py-2 px-3 rubriq-dropdown-item",
    onClick: function onClick() {
      return !isPdfFailed && onDownload(true);
    },
    disabled: isPdfFailed
  }, /*#__PURE__*/React.createElement("span", {
    className: isPdfFailed ? 'text-muted' : ''
  }, /*#__PURE__*/React.createElement(T, {
    source: "PDF with tracked changes"
  })), isPdfFailed && /*#__PURE__*/React.createElement(Popover, {
    content: t('unknown-error-editing-card-title'),
    className: "pe-auto",
    "data-bs-toggle": "tooltip",
    "data-bs-placement": "right"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-light fa-circle-info",
    className: "text-danger ms-2"
  }))))));
};
export default RubriqDownloadButton;